// extracted by mini-css-extract-plugin
export var section = "cloud-module--section--sXS_x";
export var content = "cloud-module--content--GDV0J";
export var jsAnimInit = "cloud-module--jsAnimInit--iqBoO";
export var title = "cloud-module--title--179Fd";
export var extra = "cloud-module--extra--2CM-n";
export var link = "cloud-module--link--2nlCu";
export var logo = "cloud-module--logo--3DHix";